import "./index.scss";

import React, { FC, forwardRef, memo } from "react";

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  extraComp?: React.ReactNode;
  hasError?: boolean;
  borderRightStraight?: boolean;
  borderLeftStraight?: boolean;
};

const InputComponent = forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { extraComp, hasError, borderRightStraight, borderLeftStraight, ...rest } = props;

  return (
    <div
      className={
        "base-input" +
        `${hasError ? " error" : ""}` +
        `${borderRightStraight ? " rangeFrom" : ""}` +
        `${borderLeftStraight ? " rangeTo" : ""}`
      }
    >
      <input ref={ref} {...rest} />
      {extraComp}
    </div>
  );
});

const Input = memo(InputComponent);
export default Input;
